import styled from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div`
  ${media.tablet} {
    margin: ${OFFSET.M} 0 0;
    width: 100%;
    border-top: 1px solid ${COLORS.BLACK40};
  }
`;

export const VariantLabel = styled.label`
  ${typography({})};
  display: flex;
  padding: ${OFFSET.XS} 0 ${OFFSET.XS} 12px;
  position: relative;
  width: 100%;
  background: ${COLORS.SILVER};

  ${media.tablet} {
    display: flex;
    border-bottom: 1px solid ${COLORS.BLACK40};
    background-color: transparent;
    padding: ${OFFSET.XS} 0;
    position: relative;
    width: 100%;
  }
`;

export const VariantSelect = styled.select`
  border: none;
  margin-left: 5px;
  -webkit-appearance: none;
  background-color: transparent;
  width: 100%;
  outline: none;
  padding-right: ${OFFSET.XS};
  text-overflow: ellipsis;
  color: ${COLORS.BLACK};
`;

export const LabelCopy = styled.span`
  pointer-events: none;
  ${media.tablet} {
    display: inline;
  }
`;

export const VariantOption = styled.option``;
